<template>
  <div class="number-input-unit niunits">
    <NumberInput
      v-bind="inputProps"
      ref="input"
      :value="inputValue"
      :inputmode="mobile ? 'decimal' : 'text'"
      :hasMinus="false"
      :hasPlus="false"
      style="
        --input-width: var(--input-units-width);
        --input-color: var(--clr-ipoop-active);
        --input-padding: 0 1rem 0 0;
      "
      @input:all="handleInputAll"
      @keydown="e => $emit('input:keydown', e)"
    >
      <template #after="inputScope">
        <div class="niunits_units">
          <GwMenu
            trigger="hover"
            placement="bottom"
            :ignoreDataGwmenu="true"
            :flOptions="{ offset: 0, padding: 0 }"
          >
            <template #opener>
              <div
                class="gw_btn gw_btn_text gw_btn_outline"
                style="
                  margin: 2px;
                  --padding: 0px;
                  --height: calc(1.5rem - 4px);
                  --width: 1.75rem;
                  --padding: 0.25rem 0.5rem;
                  --clr-back: var(--input-background);
                  color: var(--input-color);
                  font-size: 0.875rem !important;
                  font-weight: 700;
                "
                data-tst="ni_unit_menu_opener"
              >
                {{ { b: 'bb' }[unitValue] || unitValue }}
              </div>
            </template>
            <template #default="{ methods }">
              <div
                class="gw_menu"
                style="padding: 0.25rem 0.25rem"
              >
                <GwBtns
                  class="gwbtns_vertical_grey"
                  :options="unitsOptions"
                  :value="unitValue"
                  style="
                    --gwbtns-wrap: wrap;
                    --gwbtns-padding: 0px;
                    --gwbtn-height: 1.5rem;
                    --gwbtn-width: 1.5rem;
                    --gwbtn-padding: 0.25rem 0.5rem;
                    --gwbtn-flex: 1;
                    --gwbtn-weight: 700;
                    --gwbtn-clr-active-white: var(--clr-black-2-1);
                    --gwbtn-justify-content: center;
                  "
                  tstPrefix="ni_unit"
                  @click="
                    (_e, i) => {
                      handleUnitClick(i)
                      inputScope.methods.focusInput(['selectText'])
                      methods.toggleOpen(false)
                    }
                  "
                >
                  <template #default="{ item }">
                    <slot
                      name="unit_btn"
                      :item="item"
                    >
                      {{ { b: 'bb' }[item] || item }}
                    </slot>
                  </template>
                </GwBtns>
              </div>
            </template>
          </GwMenu>
        </div>
      </template>
    </NumberInput>
  </div>
</template>

<script>
import NumberInput from '@/components/lib/NumberInput'
import GwBtns from '@/components/lib/GwBtns'
import GwMenu from '@/components/lib/GwMenu'

export default {
  name: 'NumberInputUnit',
  components: {
    NumberInput,
    GwBtns,
    GwMenu,
  },
  props: {
    inputProps: { default: () => ({}) },
    inputValue: { default: () => -99 },
    unitValue: { default: () => '??' },
    unitsOptions: { default: () => [] },
  },
  emits: ['input:all', 'input:keydown', 'click:unit', 'input'],
  methods: {
    handleInputAll(inputConf) {
      const unit = this.unitsOptions.find(unitOption =>
        `${inputConf.origVal}`.includes(unitOption[0]),
      ) // 'bb', '%', 'e', 'x' - bb is a special case unit[0]
      if (unit && unit !== this.unitValue) {
        this.handleUnitClick(unit)
      }
      this.$emit('input:all', inputConf)
    },
    handleUnitClick(unit) {
      this.$emit('click:unit', unit)

      let newInputVal = this.inputValue.toString().replace(this.unitValue, '')
      newInputVal = `${newInputVal}${unit}`
      if (this.$refs.input) {
        const res = this.$refs.input.getParsedVal(newInputVal)
        if (res.emitInput) {
          if (!res.val.includes(unit)) {
            // min max handler resets this - we should keep units separate I think
            res.val = `${res.val}${unit}`
          }
          this.$emit('input', res.numVal)
          this.$emit('input:all', res)
        }
      }
    },
    focusInput() {
      if (!this.$refs.input) return
      this.$refs.input.focusInput()
    },
  },
  computed: {
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>

<style lang="scss" scoped>
.niunits {
  display: flex;
  position: relative;
  --input-units-width: 100%;
  &_units {
    z-index: 3;
    position: absolute;
    right: 0;
    &:hover {
      z-index: 6;
    }
  }
}
</style>
